import { Spinner } from "@sfc/ui";

export default function LoadingSpinner() {
  return (
    <div className="absolute right-1/2 bottom-1/2 translate-x-1/2 translate-y-1/2">
      <Spinner className="size-8 text-muted-foreground" />
    </div>
  );
}
